//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.DrawingPartBuilderList.js";
import "../Features/Features.ShipDesign.ShipPrimarySectionBuilder.js";
import "../Features/Features.ShipDesign.SectionViewBuilderList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"DrawingPartList",0,"Features.ShipDesign.DrawingPartBuilderList",0],[0,"SectionsPerDrawing",1,0],[1,"ShipPrimarySection",0,"Features.ShipDesign.ShipPrimarySectionBuilder",0],[1,"ViewList",0,"Features.ShipDesign.SectionViewBuilderList",0],[0,"ViewType",1,0],[0,"ViewsPerSheet",1,0]],[[[],"CreateSectionViewBuilder",{R_:{viewBuilder:"Features.ShipDesign.SectionViewBuilder"}},0,0],[["frame","offset","frontProximity","backProximity","num_focus_plates"],"FindFocusPlates",{R_:{focus_plates:"NXObject[]"}},4,0],[["frame","direction","offset","frontProximity","backProximity","num_focus_plates"],"FindFocusPlates1",{R_:{focus_plates:"NXObject[]"}},5,0],[["drawingPart"],"CreateDrawingPartBuilder",{R_:{drawingPartBuilder:"Features.ShipDesign.DrawingPartBuilder"}},1,0]],[]];
SPLM.Features.ShipDesign.SectionDrawingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SectionDrawingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SectionDrawingBuilder.SectionsPerDrawingOptions = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

SPLM.Features.ShipDesign.SectionDrawingBuilder.ViewsPerSheetOptions = Object.freeze({
    "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six"});

SPLM.Features.ShipDesign.SectionDrawingBuilder.ViewTypeOptions = Object.freeze({
    "BasicDesign" : "BasicDesign", "DetailDesign" : "DetailDesign"});

export default SPLM;